{% block neti_next_ior_settings_icon %}
    <img
        width="48"
        height="48"
        class="neti-next-ior__plugin"
        :src="assetFilter('/netinextincompleteorderreminder/administration/static/img/plugin.png')"
    />
{% endblock %}